import {
  Box,
  Typography,
  ButtonBase,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import LoadingPage from "../../Loader";
import primaryBg from "../../assets/Backgrounds/primaryBg.svg";
import Footer from "../home/Footer";
import missionIcon from "../../assets/icons/about/Asset 1.png";
import vissionIcon from "../../assets/icons/about/Asset 2.png";
import valuesIcon from "../../assets/icons/about/Asset 3.png";
import home_RotatingIcon from "../../assets/home_Rotating.svg";

import CeoTeams from "./CeoTeams";
import AdminTeams from "./AdminTeams";
import OtherTeams from "./OtherTeams";

const About = () => {
  const [settings, setSettings] = useState([]);
  const [aboutUs, setAboutUs] = useState([]);
  const [ourTeam, setOurTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imagebackground, setImageBackground] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("history");
  const { getData } = useAuth();

  const category = [
    { id: 1, categories: "history", title: "Our History" },
    { id: 2, categories: "steam", title: "What is STEAM" },
    { id: 3, categories: "benefits", title: "STEAM Benefits" },
  ];

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const response = await getData("proccess.php", "websettings"); // Fetch adverts data
        if (response.success) {
          setSettings(response.data);
        } else {
          console.error(response.message || "Failed to load adverts data");
        }

        const responseAbout = await getData("proccess.php", "about_us"); // Fetch adverts data
        if (responseAbout.success) {
          setAboutUs(responseAbout.data);
        } else {
          console.error(responseAbout.message || "Failed to load adverts data");
        }

        const responseTeam = await getData("proccess.php", "staffs"); // Fetch adverts data
        if (responseTeam.success) {
          setOurTeam(responseTeam.data);
        } else {
          console.error(responseTeam.message || "Failed to load adverts data");
        }

        // Fetch backgrounds
        const backgroundResponse = await getData("proccess.php", "backgrounds");
        if (Array.isArray(backgroundResponse.data)) {
          const aboutimg = backgroundResponse.data.filter(
            (bg) => bg.page_name === "about"
          );
          setImageBackground(aboutimg);
        } else {
          console.error(
            "Expected an array for backgrounds, but got:",
            backgroundResponse
          );
          setImageBackground([]);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError("Failed to load data. Please try again later.");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [getData]); // Added dependency array

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <Box
        minHeight="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  const ceoTeams = ourTeam.filter(
    (team) => team.role === "ceo" && team.status === "active"
  );
  const adminTeams = ourTeam.filter(
    (team) =>
      ["admin", "hr", "manager", "supervisor"].includes(team.role) &&
      team.status === "active"
  );
  const otherTeams = ourTeam.filter(
    (team) =>
      team.role !== "ceo" &&
      team.role !== "admin" &&
      team.role !== "supervisor" &&
      team.role !== "hr" &&
      team.role !== "manager" &&
      team.Id !== 36 &&
      team.status === "active"
  );

  // Fallback background image if imagebackground[0] is undefined
  const backgroundImage = imagebackground[0]?.image
    ? `url(https://mindsinaction.com.na/assets/media/pictures/${imagebackground[0].image})`
    : `url(${primaryBg})`;

  return (
    <div className="parentContainer">
      <div
        className="primary-background"
        style={{
          backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100%",
          width: "100%",
        }}
      ></div>
      <Box
        minHeight={"40vh"}
        width={"100%"}
        sx={{
          backgroundPosition: "start",
          backgroundSize: "cover",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#ffffffff",
            width: "100%",
            minHeight: "40vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "1200px",
              minHeight: "50vh",
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "100px",
              marginBottom: "50px",
              padding: "1rem",
            }}
          >
            <Box
              sx={{
                flex: 1,
                minWidth: "300px",
                textAlign: "start",
                borderRadius: "1rem",
                padding: "1rem",
              }}
            >
              <h1
                className="primary-header"
                style={{ color: "#000000ff", margin: "2rem 0 2rem 0" }}
                data-aos="fade-left"
                data-aos-delay="400"
              >
                About Us
              </h1>
              <Box
                sx={{
                  width: '100%',
                  maxHeight: '280px',
                  overflowX: 'hidden',
                  overflowY: 'auto'
                }}
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: settings[0]?.description || "",
                  }}
                  variant={{ xs: "body1", md: "h6" }}
                  color="#000000ff"
                  sx={{
                    fontSize: { xs: "1rem", md: "1.25rem" },
                    lineHeight: 1.4,
                  }}
                  
                />
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                minWidth: "300px",
                maxWidth: "600px",
                maxHeight: "350px",
                overflow: "hidden",
                borderRadius: "1rem",
              }}
              data-aos="zoom-in"
            data-aos-delay="400"
            >
              {imagebackground[1] && (
                <img
                  src={`https://mindsinaction.com.na/assets/media/pictures/${imagebackground[1].image}`}
                  style={{
                    width: "100%", height: "100%", objectFit: "cover"
                  }}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        minHeight={{ xs: "auto", md: "40vh" }}
        width={"100%"}
        sx={{ backgroundColor: "#e7f1f5" }}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        padding={{ xs: "0.5rem", md: "1rem 1rem 3rem 1rem" }}
        position={"relative"}
        zIndex={"1"}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "1000px",
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
            margin: "4rem 0 2rem 0",
          }}
        >
          <Box
            sx={{
              flex: 1,
              minWidth: "200px",
              textAlign: "center",
              border: ".1rem solid #90ca25",
              borderRadius: "1rem",
              backgroundColor: "#3b76b2de",
              overflow: "hidden",
            }}
            data-aos="flip-left"
            data-aos-delay="400"
          >
            <img
              style={{ width: "50px", margin: "1rem" }}
              src={missionIcon}
              alt="mission"
            />
            <h1
              className="primary-header"
              style={{ color: "#90ca25", backgroundColor: "#fff" }}
            >
              Mission
            </h1>
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "1.2rem",
              }}
            >
              {settings[0]?.mission || ""}
            </p>
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: "200px",
              textAlign: "center",
              border: ".1rem solid #90ca25",
              borderRadius: "1rem",
              backgroundColor: "#3b76b2de",
              overflow: "hidden",
            }}
            data-aos="flip-left"
            data-aos-delay="400"
          >
            <img
              style={{ width: "60px", margin: "1rem" }}
              src={vissionIcon}
              alt="mission"
            />
            <h1
              className="primary-header"
              style={{ color: "#90ca25", backgroundColor: "#fff" }}
            >
              Vision
            </h1>
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "1.2rem",
              }}
            >
              {settings[0]?.vision || ""}
            </p>
          </Box>

          <Box
            sx={{
              flex: 1,
              minWidth: "200px",
              textAlign: "center",
              border: ".1rem solid #90ca25",
              borderRadius: "1rem",
              backgroundColor: "#3b76b2de",
              overflow: "hidden",
            }}
            data-aos="flip-left"
            data-aos-delay="400"
          >
            <img
              style={{ width: "52px", margin: "1rem" }}
              src={valuesIcon}
              alt="mission"
            />
            <h1
              className="primary-header"
              style={{ color: "#90ca25", backgroundColor: "#fff" }}
            >
              Values
            </h1>
            <p
              style={{
                textAlign: "center",
                color: "#fff",
                fontSize: "1.2rem",
              }}
            >
              {settings[0]?.value || ""}
            </p>
          </Box>
        </Box>
        <Box
          sx={{ width: "100%", maxWidth: "1200px" }}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box
            sx={{ width: { xs: "80%", sm: "85%", md: "90%" } }}
            position={"relative"}
            zIndex={"1"}
            marginTop={"50px"}
          >
            <img
              className="gear-icon"
              style={{
                width: "100px",
                position: "absolute",
                top: "-30px",
                right: "-30px",
                zIndex: "1",
              }}
              src={home_RotatingIcon}
              alt="rotating gear"
            />
            <Box
              sx={{
                width: "100%",
                maxWidth: "1200px",
              }}
              boxShadow={3}
              borderRadius={"1rem"}
              position={"relative"}
              overflow={"hidden"}
              zIndex={"1"}
            >
              <Box position={"relative"} zIndex={"1"}>
                {/* replace this tabs */}
                <Box
                  sx={{
                    background: "#ffffffff",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", sm: "none", md: "block" },
                    }}
                  >
                    {category.length > 0 &&
                      category.map((cat) => (
                        <ButtonBase
                          key={cat.id}
                          onClick={() => setSelectedCategory(cat.categories)}
                          sx={{
                            backgroundColor:
                              cat.categories === selectedCategory
                                ? "#3b76b2"
                                : "transparent",
                            padding: "1rem",
                            color:
                              cat.categories === selectedCategory
                                ? "#ffffffff"
                                : "#000000ff",
                            fontSize: "1.3rem",
                          }}
                        >
                          {cat.title}
                        </ButtonBase>
                      ))}
                  </Box>

                  {/* Mobile dropdown */}
                  <Box
                    sx={{
                      display: { xs: "block", sm: "block", md: "none" },
                      padding: "1rem",
                    }}
                  >
                    <FormControl variant="standard">
                      <Select
                        labelId="categories-label"
                        id="categories"
                        value={selectedCategory}
                        label="Categories"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                        variant="standard"
                      >
                        {category.length > 0 &&
                          category.map((cat) => (
                            <MenuItem
                              key={cat.categories}
                              value={cat.categories}
                            >
                              {cat.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>

                {selectedCategory === "history" && (
                  <Box
                    sx={{
                      background: "#3b76b2",
                    }}
                    width={"100%"}
                    minHeight={{ xs: "auto", md: "20vh" }}
                    padding={{ xs: "1rem", md: "1rem" }}
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: aboutUs[0]?.history || "",
                      }}
                      variant={{ xs: "body1", md: "h6" }}
                      color="#fff"
                      sx={{
                        fontSize: { xs: "1rem", md: "1.25rem" },
                        lineHeight: 1.4,
                      }}
                    />
                  </Box>
                )}

                {selectedCategory === "steam" && (
                  <Box
                    sx={{
                      background: "#3b76b2",
                    }}
                    width={"100%"}
                    minHeight={{ xs: "auto", md: "20vh" }}
                    padding={{ xs: "1rem", md: "1rem" }}
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: aboutUs[0]?.steam_means || "",
                      }}
                      variant={{ xs: "body1", md: "h6" }}
                      color="#fff"
                      sx={{
                        fontSize: { xs: "1rem", md: "1.25rem" },
                        lineHeight: 1.4,
                      }}
                    />
                  </Box>
                )}

                {selectedCategory === "benefits" && (
                  <Box
                    sx={{
                      background: "#3b76b2",
                    }}
                    width={"100%"}
                    minHeight={{ xs: "auto", md: "20vh" }}
                    padding={{ xs: "1rem", md: "1rem" }}
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: aboutUs[0]?.steam_benefits || "",
                      }}
                      variant={{ xs: "body1", md: "h6" }}
                      color="#fff"
                      sx={{
                        fontSize: { xs: "1rem", md: "1.25rem" },
                        lineHeight: 1.4,
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        width={"100%"}
        sx={{ backgroundColor: "#000000ad" }}
        height={{xs: 'auto',sm:"200px"}}
        paddingTop={{xs: '2rem', sm: 'none'}}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box
            width={"90%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            gap={{xs: '2rem', sm: 'auto'}}
          >
            <h1
              className="primary-header"
              style={{ color: "#ffffffff", margin: "0" }}
              data-aos="fade-down"
              data-aos-delay="400"
            >
              THE DREAM TEAM
            </h1>
            <p
              style={{ color: "#fff", fontSize: "1.1rem", textAlign: "center" }}
              data-aos="fade-up"
              data-aos-delay="400"
            >
              We believe that by fostering curiosity, encouraging collaborative
              problem-solving, and valuing diverse perspectives, we empower our
              team and community to shape future-ready skills.
            </p>
          </Box>
        </Box>
      </Box>

      <Box
        width={"100%"}
        sx={{ backgroundColor: "#e7f1f5" }}
        minHeight={"20vh"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          width={"100%"}
          maxWidth={"1200px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box
            width={"100%"}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {ourTeam.length > 0 ? (
              <Box
                width={"100%"}
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                justifyContent={"center"}
                marginTop={"3rem"}
              >
                {/* ceo */}
                <Box
                  width={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  overflow={"hidden"}
                  marginBottom={"2rem"}
                  padding={"1rem"}
                >
                  <CeoTeams teams={ceoTeams} />
                </Box>

                {/* admin */}
                <Box
                  width={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  overflow={"hidden"}
                  marginBottom={"2rem"}
                  padding={".5rem"}
                >
                  <AdminTeams teams={adminTeams} />
                </Box>

                {/* Others */}
                <Box
                  width={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  overflow={"hidden"}
                  marginBottom={"2rem"}
                  padding={".5rem"}
                >
                  <OtherTeams teams={otherTeams} />
                </Box>
              </Box>
            ) : (
              <>No team members available</>
            )}
          </Box>
        </Box>
      </Box>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default About;
